import React from 'react';
import './App.css';
import { withCookies } from 'react-cookie';
import Routes from './Routes';
import 'semantic-ui-css/semantic.min.css';

const App = ({ cookies }) => {
  return (
    <React.Fragment>
      <Routes cookies={!!cookies.get('user')} />
    </React.Fragment>
  );
};

export default withCookies(App);



// WEBPACK FOOTER //
// ./src/App.js